/*
 *
 * translation phrase marker
 *
 */
export default function __t (s: string): string {
  return s
}
